import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
/* istanbul ignore file */

const styles = ({
  palette: {
    primary: { dark, normal }
  },
  typography
}) => ({
  link: {
    background: 'transparent',
    border: 'none',
    color: normal,
    display: 'inline-block',
    padding: 0,
    fontFamily: typography.headline2.fontFamily,
    '& svg': {
      fill: normal
    },
    '&:hover, &:focus': {
      color: dark,
      textDecoration: 'underline',
      '& svg': {
        fill: dark
      }
    }
  }
});

export function ThemedLinkComponent({ bare, className, classes, onClick, theme, ...props }) {
  if (onClick) {
    return (
      <button className={classnames(classes.link, className)} onClick={onClick} {...props}>
        {props.children}
      </button>
    );
  }
  if (bare) {
    const { children, to, ...rest } = props;
    return (
      <a className={classnames(classes.link, className)} href={to} {...rest}>
        {children}
      </a>
    );
  }
  return <Link className={classnames(classes.link, className)} {...props} />;
}

ThemedLinkComponent.defaultProps = {
  bare: false,
  classes: {},
  className: null,
  onClick: null,
  theme: {},
  children: null,
  to: null
};

ThemedLinkComponent.propTypes = {
  bare: PropTypes.bool,
  classes: PropTypes.shape({}),
  className: PropTypes.string,
  onClick: PropTypes.func,
  theme: PropTypes.shape({}),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.shape({})]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
};

export default withStyles(styles)(ThemedLinkComponent);
